import React from 'react';
import { Card, Form, InputNumber, Row } from 'antd';
import { FormInstance } from 'antd/lib/form';
import FormInput from 'components/FormInput';
import ParListSelect from 'components/ParListSelect';
import CCardButton from 'components/CCardButton';
import UtinaCard from 'components/UtinaCard';
import PricingListFilteredSelect from 'components/PricingListFilteredSelect';
import { shouldUpdateCompare } from 'utils/utils2';
import Address from 'components/address/Address';
import TaskInputByTaskTrigger from 'components/TaskInputByTaskTrigger';
import GetLabel from 'DisplayFramework/components/GetLabel';

export type InvoicingAndPaymentProps = {
  form: FormInstance;
};

const InvoicingAndPayment = ({ form }: InvoicingAndPaymentProps) => {
  return (
    <Card
      title={
        <GetLabel
          label="finElement"
          style={{ fontWeight: 'bold', paddingLeft: 15 }}
        />
      }
      style={{
        width: '100%',
        boxShadow:
          'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
      }}
      className="p-13"
    >
      <Row>
        <UtinaCard level={3} comcode="payment" lg={13}>
          <Row gutter={16}>
            <Form.Item shouldUpdate={() => true} noStyle>
              {({ getFieldValue }) => {
                return (
                  <FormInput col xs={24} md={6} name="ctpaymentmode">
                    <ParListSelect
                      parcode="PAYMODEIN"
                      offerid={getFieldValue('offerid')}
                    />
                  </FormInput>
                );
              }}
            </Form.Item>

            <Form.Item shouldUpdate={() => true} noStyle>
              {({ getFieldValue }) =>
                getFieldValue('ctpaymentmode') !== 'CCARD' ? (
                  <FormInput col xs={24} md={14} name="ctiban" />
                ) : null
              }
            </Form.Item>
          </Row>
          <Row gutter={16}>
            <Form.Item shouldUpdate={() => true} noStyle>
              {({ getFieldValue }) =>
                getFieldValue('ctpaymentmode') !== 'CCARD' ? (
                  <FormInput col xs={24} md={6} name="ctbic" />
                ) : null
              }
            </Form.Item>

            <Form.Item shouldUpdate={() => true} noStyle>
              {({ getFieldValue }) =>
                getFieldValue('ctpaymentmode') !== 'CCARD' ? (
                  <FormInput col xs={24} md={7} name="ctbankname" />
                ) : null
              }
            </Form.Item>

            <Form.Item shouldUpdate={() => true} noStyle>
              {({ getFieldValue }) =>
                getFieldValue('ctpaymentmode') === 'CCARD' ? (
                  <FormInput col xs={24} md={12} comcode="ccardlink">
                    <CCardButton comcode="ccardlink" twoToneColor="red" />
                  </FormInput>
                ) : null
              }
            </Form.Item>
            <FormInput col xs={24} md={7} name="ctpaymentdelay">
              {/* <InputNumber defaultValue={0} /> */}
              <ParListSelect parcode="PAYDELAYIN" />
            </FormInput>
          </Row>
        </UtinaCard>
        <UtinaCard level={3} comcode="formula" lg={9}>
          <Row gutter={16}>
            <Form.Item shouldUpdate={shouldUpdateCompare('client')} noStyle>
              {({ getFieldValue }) => {
                return (
                  <FormInput col xs={24} md={12} name="ctlateinterestformula">
                    <PricingListFilteredSelect
                      allowClear
                      params={{
                        offerid: 0,
                        ctetype: 'LATEIN',
                        prcode: '',
                        entity: '',
                        entityid: 0,
                        tpid: getFieldValue('client')?.tpid ?? 0,
                      }}
                    />
                  </FormInput>
                );
              }}
            </Form.Item>

            {/* <FormInput col xs={24} md={4} name="ctflagreminder">
          <Switch />
        </FormInput> */}
            <Form.Item
              shouldUpdate={shouldUpdateCompare([
                'flagmasterfacility',
                'mfprcode',
                'prcode',
              ])}
              noStyle
            >
              {({ getFieldValue }) => {
                return (
                  <FormInput col xs={24} md={12} name="cttotalpayoffformula">
                    <PricingListFilteredSelect
                      allowClear
                      params={{
                        offerid: 0,
                        ctetype: 'TPOF',
                        prcode: getFieldValue('flagmasterfacility')
                          ? getFieldValue('mfprcode')
                          : getFieldValue('prcode') ?? '',
                        entity: '',
                        entityid: 0,
                        tpid: 0,
                      }}
                    />
                  </FormInput>
                );
              }}
            </Form.Item>
          </Row>
          <Row gutter={16}>
            <Form.Item
              shouldUpdate={shouldUpdateCompare([
                'flagmasterfacility',
                'mfprcode',
                'prcode',
              ])}
              noStyle
            >
              {({ getFieldValue }) => {
                return (
                  <FormInput col xs={24} md={12} name="ctpartialpayoffformula">
                    <PricingListFilteredSelect
                      allowClear
                      params={{
                        offerid: 0,
                        ctetype: 'PPOF',
                        prcode: getFieldValue('flagmasterfacility')
                          ? getFieldValue('mfprcode')
                          : getFieldValue('prcode') ?? '',
                        entity: '',
                        entityid: 0,
                        tpid: 0,
                      }}
                    />
                  </FormInput>
                );
              }}
            </Form.Item>

            <Form.Item
              shouldUpdate={shouldUpdateCompare([
                'flagmasterfacility',
                'mfprcode',
                'prcode',
                'offerid',
              ])}
              noStyle
            >
              {({ getFieldValue }) => {
                return (
                  <FormInput
                    col
                    xs={24}
                    md={12}
                    name="ctmodificationfeesformula"
                  >
                    <PricingListFilteredSelect
                      allowClear
                      params={{
                        offerid: getFieldValue('offerid') ?? 0,
                        ctetype: 'MODFEES',
                        prcode: getFieldValue('flagmasterfacility')
                          ? getFieldValue('mfprcode')
                          : getFieldValue('prcode') ?? '',
                        entity: '',
                        entityid: 0,
                        tpid: 0,
                      }}
                    />
                  </FormInput>
                );
              }}
            </Form.Item>
          </Row>
          <Row>
            <Form.Item
              shouldUpdate={shouldUpdateCompare([
                'flagmasterfacility',
                'mfprcode',
                'prcode',
                'offerid',
              ])}
              noStyle
            >
              {({ getFieldValue }) => {
                return (
                  <FormInput
                    col
                    xs={24}
                    md={16}
                    name="ctdegradationfeesformula"
                  >
                    <PricingListFilteredSelect
                      allowClear
                      params={{
                        offerid: getFieldValue('offerid') ?? 0,
                        ctetype: 'DEGFEES',
                        prcode: getFieldValue('flagmasterfacility')
                          ? getFieldValue('mfprcode')
                          : getFieldValue('prcode') ?? '',
                        entity: '',
                        entityid: 0,
                        tpid: 0,
                      }}
                    />
                  </FormInput>
                );
              }}
            </Form.Item>
          </Row>
          <Row>
            <Form.Item
              shouldUpdate={shouldUpdateCompare([
                'flagmasterfacility',
                'mfprcode',
                'prcode',
                'offerid',
              ])}
              noStyle
            >
              {({ getFieldValue }) => {
                return (
                  <FormInput col xs={24} md={16} name="ctexeedfeesformula">
                    <PricingListFilteredSelect
                      allowClear
                      params={{
                        offerid: getFieldValue('offerid') ?? 0,
                        ctetype: 'ASSUSE',
                        prcode: getFieldValue('flagmasterfacility')
                          ? getFieldValue('mfprcode')
                          : getFieldValue('prcode') ?? '',
                        entity: '',
                        entityid: 0,
                        tpid: 0,
                      }}
                    />
                  </FormInput>
                );
              }}
            </Form.Item>
          </Row>
        </UtinaCard>
      </Row>
      <Row>
        <UtinaCard level={3} comcode="invoice-address" lg={13}>
          <Row gutter={16}>
            <FormInput col xs={24} md={8} name="ctinvoicingmode">
              <ParListSelect parcode="INVMODE" />
            </FormInput>
            <FormInput col xs={24} md={8} name="ctinvoicesendingmode">
              <ParListSelect parcode="INVSENDMOD" />
            </FormInput>
            <FormInput col xs={24} md={8} name="ctinvoiceaddressname" />
            <FormInput col xs={24} md={12} name="ctinvoiceaddressstr1" />
            <FormInput col xs={24} md={12} name="ctinvoiceaddressstr2" />
          </Row>
          <Row gutter={16}>
            {/* <FormInput col xs={24} md={6} name="ctinvoiceaddresszipcode" />

            <FormInput col xs={24} md={10} name="ctinvoiceaddresscity" />
            <FormInput col xs={24} md={8} name="ctinvoiceaddressregion" />
            <FormInput col xs={24} md={8} name="tpinvoiceaddresscountry" /> */}

            <Address
              form={form}
              paysField="tpinvoiceaddresscountry"
              regionField="ctinvoiceaddressregion"
              // regionGlobalField='tpmainadrregionglobale'
              villeField="ctinvoiceaddresscity"
              codePostalField="ctinvoiceaddresszipcode"
              style={{ marginTop: '30px' }}
              colU={7}
            />
          </Row>
        </UtinaCard>

        <UtinaCard level={3} comcode="endOfTermConditions" lg={9}>
          <Row gutter={16}>
            <FormInput col xs={24} md={12} name="ctspfeesformula">
              <PricingListFilteredSelect
                allowClear
                params={{
                  offerid: form.getFieldValue('offerid') ?? 0,
                  ctetype: 'SPFEES',
                  prcode: form.getFieldValue('flagmasterfacility')
                    ? form.getFieldValue('mfprcode')
                    : form.getFieldValue('prcode') ?? '',
                  entity: '',
                  entityid: 0,
                  tpid: 0,
                }}
              />
            </FormInput>
            <FormInput col xs={24} md={12} name="ctendofterm">
              <ParListSelect parcode="STATUSTERM" />
            </FormInput>
            <FormInput col xs={24} md={12} name="ctendoftermdelay">
              <InputNumber />
            </FormInput>
            <Form.Item shouldUpdate noStyle>
              {({ getFieldValue }) => {
                return (
                  <FormInput col xs={24} md={12} name="ctendoftermtaskid">
                    <TaskInputByTaskTrigger tasktrigger="ENDOFTERM" />
                  </FormInput>
                );
              }}
            </Form.Item>
          </Row>
        </UtinaCard>
      </Row>
    </Card>
  );
};

export default InvoicingAndPayment;
